import { useToast } from "@chatfood/design-system";
import { isBasketRepoError } from "@chatfood/dbe-client/errors";
import { useLocale } from "~/composables/use-locale";
import type { IDomainItem } from "#imports";

export const useAddItemBasketErrorValidation = () => {
  const { toastError } = useToast();
  const { t } = useLocale();

  const findModifierListName = (
    modifierLists: IDomainItem["modifierLists"],
    targetId: string,
    itemId?: string,
  ): string | undefined => {
    for (const list of modifierLists) {
      if (list.id === targetId) return list.name;

      // Search in nested modifier lists
      for (const modifier of list.modifiers) {
        if (modifier.modifierLists?.length && modifier.id !== itemId) {
          const found = findModifierListName(modifier.modifierLists, targetId);
          if (found) return found;
        }
      }
    }
  };

  const handleBasketError = (
    error: unknown,
    modifierLists: IDomainItem["modifierLists"],
    itemId?: string,
  ) => {
    if (isBasketRepoError(error) && error.isBusinessRule()) {
      const { modifierListId, minRequired, maxAllowed, actualCount } =
        error.meta?.context || {};

      const modifierListName =
        findModifierListName(modifierLists, modifierListId, itemId) ||
        "modifier list";

      let generalBusinessRuleMessage = t(
        "composables.use_add_item_basket_error_validation.generic_error",
        { modifierListName },
      );

      if (actualCount > maxAllowed) {
        generalBusinessRuleMessage = t(
          "composables.use_add_item_basket_error_validation.max_allowed_error",
          { modifierListName, maxAllowed },
        );
      }

      if (actualCount < minRequired) {
        generalBusinessRuleMessage = t(
          "composables.use_add_item_basket_error_validation.min_required_error",
          { modifierListName, minRequired },
        );
      }

      toastError(generalBusinessRuleMessage);
      return true;
    }

    return false;
  };

  return {
    handleBasketError,
  };
};
